import { useEffect, useState } from 'react';
import { configurationApi } from '@/services/configuration.api';

/**
 * Carica la percentuale di avanzamento (0..1) di una configurazione dal backend.
 * Restituisce `null` finché non è nota (in caricamento o in errore) — la UI mostra
 * uno stato indeterminato in quel caso.
 */
export function useAnsweredPercentage(configId: number): number | null {
  const [percentage, setPercentage] = useState<number | null>(null);

  useEffect(() => {
    let alive = true;
    setPercentage(null);
    configurationApi
      .getAnsweredPercentage(configId)
      .then((p) => {
        if (alive) setPercentage(p);
      })
      .catch(() => {
        if (alive) setPercentage(null);
      });
    return () => {
      alive = false;
    };
  }, [configId]);

  return percentage;
}
